const SelectionToolData = {
  config: {
    startup: {
      button: 'Get Started',
      lead:
        '<div class="image"></div><p>Use our online product selector to identify what Fleet product is best for you.</p>'
    },
    disclaimers:
      '<p>This Fleet® product selector is intended to provide information to help select the appropriate Fleet® product based on symptoms. By accessing or using this, you agree to be bound by all the terms and conditions below. This product selector is not intended to be a diagnostic health tool. The actions and products it suggests do not constitute a medical diagnosis of a specific condition and do not take the place of the diagnosis or recommendations made by your physician. Speak to your doctor if you have any questions about Fleet® products, their usage or your symptoms.</p><p>By using the Fleet® product selector you understand and agree that the information contained in this selector is not intended nor implied to be, and you will not use it as, a substitute for professional medical advice. Nothing contained in this product selector is intended to be or will be used by you for medical diagnosis or treatment. You understand that you should never disregard professional medical advice or delay in seeking treatment based on the information contained in this product selector. This product selector is not targeted to users in any particular locality, nor is it intended to constitute, and you agree that it does not constitute, the doing of business in any jurisdiction.</p>'
  },
  outcomes: [
    {
      name: 'mineral-1',
      responses: [{ id: 4, value: true }],
      content: {
        html:
          '<p>Fleet® Mineral Oil Enema is a lubricant laxative that lubricates and softens the stool to produce a bowel movement. </p>',
        product: {
          name: 'Fleet® Mineral Oil Enema',
          wtb: '/where-to-buy?sku=301320301403',
          link: '/constipation-relief-products/enemas/fleet-mineral-oil-enema',
          image: 'product-mineral.png'
        }
      }
    },
    {
      name: 'saline-1',
      responses: [
        { id: 2, value: true },
        { id: 4, value: false }
      ],
      content: {
        html:
          '<p>The Fleet® Enema is a saline laxative that provides reliable relief from occasional constipation without pain or spasm.</p>',
        product: {
          name: 'Fleet® Saline Enema',
          wtb: '/where-to-buy?sku=301320201451',
          link: '/constipation-relief-products/enemas/fleet-saline-enema',
          disclaimer:
            'Do not use unless recommended by a doctor if you have kidney disease, heart disease, are dehydrated or have nausea and vomiting.  Do not use more than one enema in 24 hours and no more than three days in a row.',
          image: 'product-saline.png'
        }
      }
    },
    {
      name: 'liquid-1',
      responses: [
        { id: 2, value: false },
        { id: 4, value: false }
      ],
      content: {
        html:
          '<p>Fleet® Liquid Glycerin Suppositories provide fast relief for occasional constipation with a no-mess applicator.</p>',
        product: {
          name: 'Fleet® Liquid Glycerin Suppositories',
          wtb: '/where-to-buy?sku=301320185829',
          link:
            '/constipation-relief-products/suppositories/fleet-liquid-glycerin-suppositories',
          image: 'product-liquidglycerin.png'
        }
      }
    },
    {
      name: 'bisacodyl-1',
      responses: [
        { id: 3, value: 'b' },
        { id: 5, value: true }
      ],
      content: {
        html:
          '<p>Fleet® Bisacodyl Enema provides fast relief of occasional constipation or bowel cleansing before rectal examination.</p>',
        product: {
          name: 'Fleet® Bisacodyl Enema',
          wtb: '/where-to-buy?sku=301320703368',
          link: '/constipation-relief-products/enemas/fleet-bisacodyl-enema',
          image: 'product-bisacodyl.png'
        }
      }
    },
    {
      name: 'saline-2',
      responses: [
        { id: 2, value: true },
        { id: 3, value: 'b' },
        { id: 5, value: false }
      ],
      content: {
        html:
          '<p>The Fleet® Enema is a saline laxative that provides reliable relief from occasional constipation without pain or spasm.</p>',
        product: {
          name: 'Fleet® Saline Enema',
          wtb: '/where-to-buy?sku=301320201451',
          link: '/constipation-relief-products/enemas/fleet-saline-enema',
          image: 'product-saline.png'
        }
      }
    },
    {
      name: 'liquid-2',
      responses: [
        { id: 2, value: false },
        { id: 3, value: 'b' },
        { id: 5, value: false }
      ],
      content: {
        html:
          '<p>Fleet® Liquid Glycerin Suppositories provide fast relief for occasional constipation with a no-mess applicator.</p>',
        product: {
          name: 'Fleet® Liquid Glycerin Suppositories',
          wtb: '/where-to-buy?sku=301320185829',
          link:
            '/constipation-relief-products/suppositories/fleet-liquid-glycerin-suppositories',
          image: 'product-liquidglycerin.png'
        }
      }
    },
    {
      name: 'liquid-3',
      responses: [{ id: 3, value: 'c' }],
      content: {
        html:
          '<p>Fleet® Liquid Glycerin Suppositories provide fast relief for occasional constipation with a no-mess applicator.</p>',
        product: {
          name: 'Fleet® Liquid Glycerin Suppositories',
          wtb: '/where-to-buy?sku=301320185829',
          link:
            '/constipation-relief-products/suppositories/fleet-liquid-glycerin-suppositories',
          image: 'product-liquidglycerin.png'
        }
      }
    },
    {
      name: 'liquid-4',
      responses: [
        { id: 2, value: false },
        { id: 3, value: 'd' }
      ],
      content: {
        html:
          '<p>Fleet® Liquid Glycerin Suppositories provide fast relief for occasional constipation with a no-mess applicator.</p>',
        product: {
          name: 'Fleet® Liquid Glycerin Suppositories',
          wtb: '/where-to-buy?sku=301320185829',
          link:
            '/constipation-relief-products/suppositories/fleet-liquid-glycerin-suppositories',
          image: 'product-liquidglycerin.png'
        }
      }
    },
    {
      name: 'liquid-5',
      responses: [
        { id: 1, value: 'a' },
        { id: 2, value: true },
        { id: 3, value: 'd' }
      ],
      content: {
        html:
          '<p>Fleet® Liquid Glycerin Suppositories provide fast relief for occasional constipation with a no-mess applicator.</p>',
        product: {
          name: 'Fleet® Liquid Glycerin Suppositories',
          wtb: '/where-to-buy?sku=301320185829',
          link:
            '/constipation-relief-products/suppositories/fleet-liquid-glycerin-suppositories',
          image: 'product-liquidglycerin.png'
        }
      }
    },
    {
      name: 'glycerin-1',
      responses: [
        { id: 1, value: 'b' },
        { id: 2, value: true },
        { id: 3, value: 'd' }
      ],
      content: {
        html:
          '<p>Fleet® Glycerin Suppository now formulated with Aloe is a convenient alternative for those who prefer not to use liquid enemas.</p>',
        product: {
          name: 'Fleet® Glycerin Suppository',
          wtb: '/where-to-buy?sku=301320079241',
          link:
            '/constipation-relief-products/suppositories/fleet-glycerin-suppositories',
          image: 'product-suppositories.png'
        }
      }
    },
    {
      name: 'extra-1',
      responses: [
        { id: 1, value: 'c' },
        { id: 2, value: true },
        { id: 3, value: 'd' }
      ],
      content: {
        html:
          '<p>Fleet Enema EXTRA® is a great, fast-acting solution when you are experiencing constipation or if your stool is hard or difficult to pass.</p>',
        product: {
          name: 'Fleet Enema EXTRA®',
          wtb: '/where-to-buy?sku=301320201451',
          link: '/constipation-relief-products/enemas/fleet-enema-extra',
          image: 'product-salineextra.png'
        }
      }
    },
    {
      name: 'saline-3',
      responses: [
        { id: 1, value: 'e' },
        { id: 2, value: true },
        { id: 3, value: 'd' }
      ],
      content: {
        html:
          '<p>The Fleet® Enema is a saline laxative that provides reliable relief from occasional constipation without pain or spasm.</p>',
        product: {
          name: 'Fleet® Saline Enema',
          wtb: '/where-to-buy?sku=301320201451',
          link: '/constipation-relief-products/enemas/fleet-saline-enema',
          disclaimer:
            'Do not use unless recommended by a doctor if you have kidney disease, heart disease, are dehydrated or have nausea and vomiting.  Do not use more than one enema in 24 hours and no more than three days in a row.',
          image: 'product-saline.png'
        }
      }
    },
    {
      name: 'saline-4',
      responses: [
        { id: 1, value: 'e' },
        { id: 2, value: true },
        { id: 3, value: 'd' }
      ],
      content: {
        html:
          '<p>The Fleet® Enema is a saline laxative that provides reliable relief from occasional constipation without pain or spasm.</p>',
        product: {
          name: 'Fleet® Saline Enema',
          wtb: '/where-to-buy?sku=301320201451',
          link: '/constipation-relief-products/enemas/fleet-saline-enema',
          disclaimer:
            'Do not use unless recommended by a doctor if you have kidney disease, heart disease, are dehydrated or have nausea and vomiting.  Do not use more than one enema in 24 hours and no more than three days in a row.',
          image: 'product-saline.png'
        }
      }
    },
    {
      name: 'saline-5',
      responses: [
        { id: 1, value: 'd' },
        { id: 2, value: true },
        { id: 3, value: 'd' }
      ],
      content: {
        html:
          '<p>The Fleet® Enema is a saline laxative that provides reliable relief from occasional constipation without pain or spasm.</p>',
        product: {
          name: 'Fleet® Saline Enema',
          wtb: '/where-to-buy?sku=301320201451',
          link: '/constipation-relief-products/enemas/fleet-saline-enema',
          disclaimer:
            'Do not use unless recommended by a doctor if you have kidney disease, heart disease, are dehydrated or have nausea and vomiting.  Do not use more than one enema in 24 hours and no more than three days in a row.',
          image: 'product-saline.png'
        }
      }
    }
  ],
  questions: [
    {
      name: 'q1',
      text: 'Which best describes you?',
      id: 1,
      options: [
        {
          name: 'q1-a',
          text: 'I have not had a bowel movement in 2+days - I am stuck',
          value: 'a'
        },
        {
          name: 'q1-b',
          text:
            'I am having bowel movements but straining and its painful, my stool is dry and hard',
          value: 'b'
        },
        {
          name: 'q1-c',
          text:
            "I am having bowel movement but don't feel fully empty, I feel bloated.",
          value: 'c'
        },
        {
          name: 'q1-d',
          text:
            'I want to flush my system out and remove waste – I want to feel lighter',
          value: 'd'
        },
        {
          name: 'q1-e',
          text: 'I am prepping for a medical procedure',
          value: 'e'
        }
      ]
    },
    {
      name: 'q2',
      text: 'Have you used a rectal laxative in the past?',
      id: 2,
      options: [
        {
          name: 'q2-yes',
          text: 'Yes',
          value: true
        },
        {
          name: 'q2-no',
          text: 'No',
          value: false
        }
      ]
    },
    {
      name: 'q3',
      text: 'Do any of the following apply to you?',
      id: 3,
      options: [
        {
          name: 'q3-a',
          text:
            'My doctor told me I should not strain or forcefully push during a bowel movement',
          value: 'a'
        },
        {
          name: 'q3-b',
          text:
            'My doctor recommended a stimulant laxative because I require bowel stimulation',
          value: 'b'
        },
        {
          name: 'q3-c',
          text: 'I am pregnant',
          value: 'c'
        },
        {
          name: 'q3-d',
          text: 'None of the above',
          value: 'd'
        }
      ]
    },
    {
      name: 'q4',
      text:
        'Have you recently had surgery, experiencing painful hemorrhoid flare ups, recovering from childbirth or suffering from fecal impaction?',
      id: 4,
      prereq: { 3: 'a' },
      options: [
        {
          name: 'q4-yes',
          text: 'Yes',
          value: true
        },
        {
          name: 'q4-no',
          text: 'No',
          value: false
        }
      ]
    },
    {
      name: 'q5',
      text:
        'Do you require increased rhythmic action to push a bowel movement through (bowel management), are paraplegic, or suffer from spinal cord injury, neuromuscular?',
      id: 5,
      prereq: { 3: 'b' },
      options: [
        {
          name: 'q5-yes',
          text: 'Yes',
          value: true
        },
        {
          name: 'q5-no',
          text: 'No',
          value: false
        }
      ]
    }
  ],
  textpanes: []
}
export default SelectionToolData
